import {PROD} from "../config";
import moment from "moment";
import {isAudioControlBlockCounted, isAudioControlConditionCounted, sumWeights} from "../../components/Settings/AudioControlList/audioControlQuestionnaire";
import {getUserWorkScheduleError} from "../../components/Settings/UsersList/userWorkSchedulers";
import {CALLS_DIALER_TYPE, resolveCallsDialerType} from "../../types/types";

interface CampaignFormErrors {
    name?: object;
    callCycles?: any;
    callCyclesActive?: object;
    trankId?: object,
    startTime?: boolean,
    startDate?: boolean,
    endTime?: boolean,
    endDate?: boolean,
    campaignUsers?: object;
    branchId?: boolean;
    mohAudioId?: object;
    mohAudioTime?: object;
    schedulerAudioTime?: object;
    mwtAudioTime?: object;
    mwtNoAgentAudioTime?: object;
    schedulerStrategyAction?: object;
    mwtStrategyAction?: object;
    mwtNoAgentStrategyAction?: object;
    mwt?: object;
    mwtNoAgent?: object;
    schedulerStrategy?: object;
    mwtStrategy?: object;
    mwtNoAgentStrategy?: object;
    campaignACD?: object;
    inLineCountCalls?: object;
    ivmListeningTime?: object;
    ivmAudios?: object;
    audioRetries?: object;
    scheduler?: object;
    timeoutExternalOnAnswer?: object;
    campaignAMD?: Record<string, string>;
    countCycles?: object;
}

interface QueueFormErrors {
    name?: object;
    queueTranks?: object;
    scheduler?: object;
    queueUsers?: object;
    mohAudioId?: object;
    mohAudioTime?: object;
    schedulerAudioTime?: object;
    mwtAudioTime?: object;
    mwtNoAgentAudioTime?: object;
    schedulerStrategyAction?: object;
    mwtStrategyAction?: object;
    mwtNoAgentStrategyAction?: object;
    mwt?: object;
    mwtNoAgent?: object;
    schedulerStrategy?: object;
    mwtStrategy?: object;
    mwtNoAgentStrategy?: object;
    branchId?: boolean;
    schedulerAudioId?: object;
    ivmAudios?: object;
    audioRetries?: object;
    ivrConfiguration?: object;
    ivrConfigurationId?: object;
}


interface BranchDataFormErrors {
    ownerName?: object;
    name?: object;
    parentId?: object
}

interface TechDataFormErrors {
    userName?: any;
    password?: any;
    techUserPermissions?: any;
    isActive?: object;
}


interface RoleDataFormErrors {
    name?: object;
    description?: object;
    permissionId?: object
    branchId?: boolean;
}

interface StatusDataFormErrors {
    name?: object;
    description?: object;
    timeStatus?: object;
    branchId?: boolean;
}

interface AudioDataFormErrors {
    groupName?: object;
    description?: object;
    timeStatus?: object;
    branchId?: boolean;
    audioFileName?: object;
}

interface QualificationGroupDataFormErrors {
    name?: object;
    users?: object;
    branchId?: boolean;
}

interface UserFormErrors {
    userName?: any;
    roles?: any;
    password?: any,
    recruitedDate?: boolean,
    birthDate?: boolean,
    branchId?: boolean,
    phoneNo?: boolean,
    languageId?: boolean,
    email?: any,
    countryId?: boolean,
    utc?: boolean,
    firstName?: boolean,
    lastName?: boolean,
    userTrunks?: object,
    mobilePhone?: any,
    workSchedulers?: any
}

interface CallCycleErrors {
    countCalls?: string | boolean;
    timeBetweenCalls?: string | boolean;
}

interface ChangePasswordErrors {
    oldPassword?: string | boolean | any;
    newPassword?: string | boolean | any;
    confirmationPassword?: string | boolean | any;
}

interface TrunkFormErrors {
    name?: object;
    phones?: object;
    phoneRowErrors?: Record<number, string>;
    branchId?: object;
    defaultTrunkId?: object;
    listOutboundPhones?: object;
    listInboundPhones?: object;
    limitAttemptsCall?: object;
    paiNumber?: object;
}

interface IVRConfigurationFormErrors {
    name?: object;
    branchId?: boolean;
}

interface AudioControlFormErrors {
    name?: object;
    branchId?: object;
    nameUniq?: string;
    blocks?: object;
    questionnaire?: object;
    blockErrors?: Record<number, {
        name?: boolean;
        weight?: boolean;
        conditions?: Record<number, {
            condition?: boolean;
            scenario?: boolean;
            weight?: boolean;
            failCondition?: boolean;
        }>;
    }>;
}

interface recoveryEmailErrors {
    name?: object;
}

export function validateQualificationGroup(skillGroup: any): QualificationGroupDataFormErrors {
    const errors: QualificationGroupDataFormErrors = {};

    if (!skillGroup?.name) {
        errors.name = {name: 'Назва групи не може бути порожньою*'};
    }

    if (!skillGroup.skillGroupBranches?.length) {
        errors.branchId = true;
    }

    return errors;
}

export function validateUserForm(userForm: any): UserFormErrors | null {
    const errors: UserFormErrors = {};

    if (!userForm.userName) {
        errors.userName = true;
    } else {
        const regex = /^[A-Za-z\d._!*]*[A-Za-z]+[\d._!*]*$/;

        if (!regex.test(userForm.userName)) {
            errors.userName = {name: `Недопустимі символи! Логін має містити хоча б одну літеру. Використовуйте символи A-Z a-z 0-9 . _ ! * .`};
        }
    }

    if (!userForm?.mobilePhone && userForm?.callTypeReceive === 403) {
        errors.mobilePhone = {name: `Поле обов'язкове для заповнення.`};
    } else if (userForm?.callTypeReceive === 403) {
        const regex = /^380/;

        if (!regex.test(userForm.mobilePhone)) {
            errors.mobilePhone = {name: `Використовуйте формат номеру 380xxxxxxxxx`};
        } else if (regex.test(userForm.mobilePhone) && userForm.mobilePhone.length !== 12) {
            errors.mobilePhone = {name: `Використовуйте формат номеру 380xxxxxxxxx`};
        }
    }

    if (!userForm.roles || !userForm.roles?.length) {
        errors.roles = true;
    }

    if (!userForm.password) {
        errors.password = true;
    } else {
        const regex = /^(?=.*[a-zа-я])(?=.*[A-ZА-Я])(?=.*\d)[\d\S]{8,}$/;


        if (!regex.test(userForm.password)) {
            errors.password = {password: 'Пароль повинен містити мінімум одну велику літеру, одну маленьку літеру, одну цифру та містити не менше 8 символів.'};
        }
    }

    // if (userForm?.userTrunks?.length) {
    //     const allUserTrunkPhoneIdNotNull = Array?.isArray(userForm.userTrunks) && userForm.userTrunks.every((item: {
    //         trunkId: any;
    //     }) => item.trunkId !== null);
    //
    //
    //     if (!allUserTrunkPhoneIdNotNull) {
    //         errors.userTrunks = {userTrunks: 'Виберіть номер лінії*'};
    //     }
    // } else {
    //     errors.userTrunks = {userTrunks: 'Виберіть транк та номер лінії*'};
    // }

    // if (userForm?.userTrunks?.length) {
    //     const trunks = userForm.userTrunks;
    //
    //     const trunkGroups: Record<number | string, any[]> = {};
    //     const errorTrunkIds: number[] = [];
    //
    //     for (const trunk of trunks) {
    //         if (!trunk.trunkId) {
    //             errors.userTrunks = { userTrunks: 'Додайте транк або заповніть усі поля транків' };
    //             break;
    //         }
    //
    //         if (!trunkGroups[trunk.trunkId]) {
    //             trunkGroups[trunk.trunkId] = [];
    //         }
    //         trunkGroups[trunk.trunkId].push(trunk);
    //     }
    //
    //     for (const [trunkId, group] of Object.entries(trunkGroups)) {
    //         const hasInvalid502 = group.some((t: any) => t.trunkType === 502 && t.trunkPhoneId === null);
    //         const hasNullPhoneId = group.some((t: any) => t.trunkPhoneId === null);
    //         const groupHasConflict = group.length > 1 && hasNullPhoneId;
    //
    //         if (hasInvalid502 || groupHasConflict) {
    //             const numericTrunkId = Number(trunkId);
    //             if (!errorTrunkIds.includes(numericTrunkId)) {
    //                 errorTrunkIds.push(numericTrunkId);
    //             }
    //         }
    //     }
    //
    //     if (errorTrunkIds.length > 0) {
    //         errors.userTrunks = {
    //             userTrunks: 'При виборі персонального типу не можна вибирати всю групу транків',
    //             trunkIds: errorTrunkIds
    //         };
    //     }
    // }

    if (userForm?.userTrunks?.length) {
        const trunks = userForm.userTrunks;

        const trunkGroups: Record<number | string, any[]> = {};
        const errorTrunkIds: number[] = [];
        const mixed502TrunkIds: number[] = [];
        const invalid501TrunkIds: number[] = [];

        for (const trunk of trunks) {
            if (!trunk.trunkId) {
                errors.userTrunks = {
                    userTrunks: 'Додайте транк або заповніть усі поля транків'
                };
                break;
            }

            if (!trunkGroups[trunk.trunkId]) {
                trunkGroups[trunk.trunkId] = [];
            }
            trunkGroups[trunk.trunkId].push(trunk);
        }

        for (const [trunkId, group] of Object.entries(trunkGroups)) {
            const numericTrunkId = Number(trunkId);

            // === (1) Проверка: повторный null по trunkType
            const nullByType: Record<number, number> = {};
            group.forEach((t: any) => {
                if (t.trunkPhoneId === null) {
                    nullByType[t.trunkType] = (nullByType[t.trunkType] || 0) + 1;
                }
            });

            const conflictByType = Object.values(nullByType).some(count => count > 1);
            if (conflictByType && !errorTrunkIds.includes(numericTrunkId)) {
                errorTrunkIds.push(numericTrunkId);
            }

            // === (2) Проверка смешанных состояний trunkPhoneId для каждого trunkType
            const trunkTypeGroups: Record<number, { hasNull: boolean; hasNotNull: boolean }> = {};

            for (const t of group) {
                if (!trunkTypeGroups[t.trunkType]) {
                    trunkTypeGroups[t.trunkType] = {hasNull: false, hasNotNull: false};
                }

                if (t.trunkPhoneId === null) trunkTypeGroups[t.trunkType].hasNull = true;
                else trunkTypeGroups[t.trunkType].hasNotNull = true;
            }

            for (const [typeStr, state] of Object.entries(trunkTypeGroups)) {
                const type = Number(typeStr);

                if (state.hasNull) {
                    if (type === 502) {
                        if (!invalid501TrunkIds.includes(numericTrunkId)) {
                            invalid501TrunkIds.push(numericTrunkId);
                        }
                    }

                    if (type === 501 && state.hasNotNull) {
                        if (!mixed502TrunkIds.includes(numericTrunkId)) {
                            mixed502TrunkIds.push(numericTrunkId);
                        }
                    }
                }
            }
        }

        // === Приоритет ошибок ===
        if (mixed502TrunkIds.length > 0) {
            errors.userTrunks = {
                userTrunks: 'Група транків вже додана',
                trunkIds: mixed502TrunkIds
            };
        } else if (invalid501TrunkIds.length > 0) {
            errors.userTrunks = {
                userTrunks: 'При виборі персонального типу обовʼязково вкажіть телефон',
                trunkIds: invalid501TrunkIds
            };
        } else if (errorTrunkIds.length > 0) {
            errors.userTrunks = {
                userTrunks: 'Група транків вже додана',
                trunkIds: errorTrunkIds
            };
        }
    } else {
        errors.userTrunks = {
            userTrunks: 'Виберіть транк та номер лінії*'
        };
    }

    if (!userForm.branchId) {
        errors.branchId = true;
    }

    if (!userForm.languageId) {
        errors.languageId = true;
    }

    if (!userForm.email) {
        errors.email = true;
    } else {
        const emailPattern = /^[\w.%+-]+@[\w.-]+\.\w{2,}(?:\.\w{2,})?$/;
        if (emailPattern.test(userForm.email)) {
        } else {
            errors.email = {
                email: 'Не схоже на електронну адресу.\n' +
                    'Введіть, будь ласка, коректний Email- він необхідний для відновлення та зміни пароля користувача.'
            };
        }
    }

    if (!userForm.countryId) {
        errors.countryId = true;
    }

    if (!userForm.utc) {
        errors.utc = true;
    }

    if (!userForm.firstName) {
        errors.firstName = true;
    }

    if (!userForm.lastName) {
        errors.lastName = true;
    }

    const workScheduleError = getUserWorkScheduleError(userForm?.workSchedulers);
    if (workScheduleError) {
        errors.workSchedulers = workScheduleError;
    }

    return Object.keys(errors).length > 0 ? errors : null;
}

function validateCallCycle(callCycle: any, skipTimeBetweenCalls = false): CallCycleErrors {
    const errors: CallCycleErrors = {};

    const countCallsValue = Number(callCycle.countCalls);
    const hasCountCallsValue = callCycle.countCalls !== undefined && callCycle.countCalls !== null && callCycle.countCalls !== '';

    if (!hasCountCallsValue || Number.isNaN(countCallsValue)) {
        errors.countCalls = true;
    } else if (countCallsValue < 1 || countCallsValue > 100) {
        errors.countCalls = 'Значення повинно бути від 1 до 100*';
    }

    if (!skipTimeBetweenCalls) {
        const timeBetweenValue = Number(callCycle.timeBetweenCalls);
        const hasTimeBetweenValue = callCycle.timeBetweenCalls !== undefined && callCycle.timeBetweenCalls !== null && callCycle.timeBetweenCalls !== '';

        if (!hasTimeBetweenValue || Number.isNaN(timeBetweenValue)) {
            errors.timeBetweenCalls = true;
        } else if (!errors.countCalls && countCallsValue === 1 && timeBetweenValue !== 0) {
            errors.timeBetweenCalls = 'має бути 0*';
        } else if (!errors.countCalls && countCallsValue > 1 && (timeBetweenValue < 1 || timeBetweenValue > 1000)) {
            errors.timeBetweenCalls = 'Значення повинно бути від 1 до 1000*';
        }
    }

    return errors;
}

export function validateChangePassword(password: any): ChangePasswordErrors {
    const errors: ChangePasswordErrors = {};

    if (password.currentUser) {
        if (!password.oldPassword) {
            errors.oldPassword = true;
        }
    }

    if (!password.newPassword) {
        errors.newPassword = true;
    } else {
        const regex = /^(?=.*[a-zа-я])(?=.*[A-ZА-Я])(?=.*\d)[\d\S]{8,}$/;
        if (!regex.test(password.newPassword)) {
            errors.newPassword = {password: 'Пароль повинен містити мінімум одну велику літеру, одну маленьку літеру, одну цифру та містити не менше 8 символів.'};
        }
    }

    if (!password.confirmationPassword) {
        errors.confirmationPassword = 'Повторіть новий пароль*';
    } else if (password.newPassword && password.confirmationPassword !== password.newPassword) {
        errors.newPassword = true;
        errors.confirmationPassword = {password: 'Пароль  підтвердження не збігається з Новим паролем. Перевірте і повторіть спробу.'};
    }

    return errors;
}

export function validate(companiesData: any) {
    const errors: CampaignFormErrors = {};

    if (!companiesData.campaign.campaignName) {
        errors.name = {name: 'Назва кампанії не може бути порожньою'};
    }

    if (companiesData.campaign.isInLineCountCalls && (companiesData.campaign.campaignTypeId === 202 || companiesData.campaign.campaignTypeId === 204 || companiesData.campaign.campaignTypeId === 205)) {
        const value = companiesData.campaign.inLineCountCalls;
        if (!value || value < 1 || value > 100) {
            errors.inLineCountCalls = {name: 'Кількість повинна бути від 1 до 100'};
        }
    }

    const value = companiesData.campaign?.doneDurationTime;
    if (!value || value < 1) {
        errors.ivmListeningTime = {ivmListeningTime: 'Значення не може бути меньше 1. *'};
    }

    if (companiesData.campaign.campaignTypeId === 204) {
        const audioRetries = companiesData.campaignACD.audioRetries;

        if (!audioRetries || audioRetries < 1 || audioRetries > 100) {
            errors.audioRetries = {audioRetries: 'Значення не може бути меньше 1. *'};
        }
        if (companiesData.campaignACD.isIVMAudio) {
            const audios = companiesData.campaignACD.ivmAudios;
            if (!Array.isArray(audios) || audios.length < 1) {
                errors.ivmAudios = {ivmAudios: 'Потрібно обрати хоча б один аудіофайл. *'};
            }
        }

    }

    if (companiesData?.campaignUsers?.length) {
        const usersWithMissingLevel = companiesData?.campaignUsers?.filter((item: {
            userLevel: null | undefined;
        }) => item.userLevel === null || item.userLevel === undefined);

        if (usersWithMissingLevel.length > 0) {
            errors.campaignUsers = {campaignUsers: 'Рівень оператора не може бути порожнім*', campaignUsersWithoutLevel: usersWithMissingLevel};
        }
    }

    if (!companiesData.campaign.branchId) {
        errors.branchId = true;
    }

    if (companiesData.campaign.isGeneralTrunk) {
        const trunks = companiesData.trunks || [];

        const trunkGroups: Record<number | string, any[]> = {};

        for (const trunk of trunks) {
            if (!trunkGroups[trunk.trunkId]) {
                trunkGroups[trunk.trunkId] = [];
            }
            trunkGroups[trunk.trunkId].push(trunk);
        }

        const hasInvalidTrunkGroup = Object.values(trunkGroups).some((group) => {
            const hasNull = group.some((t: any) => t.trunkPhoneId === null);
            return group.length > 1 && hasNull;
        });

        if (hasInvalidTrunkGroup) {

        }
    }

    if (companiesData.campaign.isGeneralTrunk) {
        const trunks = companiesData.trunks || [];

        if (!trunks.length) {
            errors.trankId = {campaignTranks: 'Відсутні транк'};
        } else {
            const trunkGroups: Record<number | string, any[]> = {};
            const errorTrunkIds: number[] = [];

            for (const trunk of trunks) {
                if (!trunk.trunkId) {
                    errors.trankId = {campaignTranks: 'Заповніть усі поля транків'};
                    break;
                }

                if (!trunkGroups[trunk.trunkId]) {
                    trunkGroups[trunk.trunkId] = [];
                }
                trunkGroups[trunk.trunkId].push(trunk);
            }

            for (const [trunkId, group] of Object.entries(trunkGroups)) {
                const hasNull = group.some((t: any) => t.trunkPhoneId === null);
                if (group.length > 1 && hasNull) {
                    const numericTrunkId = Number(trunkId);
                    if (!errorTrunkIds.includes(numericTrunkId)) {
                        errorTrunkIds.push(numericTrunkId);
                    }
                }
            }

            if (errorTrunkIds.length > 0) {
                errors.trankId = {
                    campaignTranks: 'Цей транк вже додано в кампанію',
                    trunkIds: errorTrunkIds
                };
            }
        }
    }

    const isSequentiallyByCycle = resolveCallsDialerType(companiesData.campaign) === CALLS_DIALER_TYPE.sequentialByCycle;
    const callCycleErrors = companiesData.callCycles.map((callCycle: any) => validateCallCycle(callCycle, isSequentiallyByCycle));

    if (callCycleErrors.some((callCycleError: {}) => Object.keys(callCycleError).length > 0)) {
        const callCycleErrorsByTypeCall: any = {};
        companiesData.callCycles.forEach((callCycle: any, index: number) => {
            if (Object.keys(callCycleErrors[index]).length > 0) {
                callCycleErrorsByTypeCall[callCycle.typeCall] = callCycleErrors[index];
            }
        });
        errors.callCycles = callCycleErrorsByTypeCall;
    }

    if (!companiesData.callCycles || !companiesData.callCycles.some((callCycle: any) => callCycle?.isActive)) {
        errors.callCyclesActive = {message: 'Необхідно активувати хоча б один тип контакту*'};
    }

    if (isSequentiallyByCycle) {
        const totalCountValue = Number(companiesData.callCycles?.[0]?.totalCount);
        const hasCountCyclesValue = companiesData.callCycles?.[0]?.totalCount !== undefined && companiesData.callCycles?.[0]?.totalCount !== null && companiesData.callCycles?.[0]?.totalCount !== '';
        const isCountCyclesValid = hasCountCyclesValue && !Number.isNaN(totalCountValue) && totalCountValue >= 1 && totalCountValue <= 100;

        if (!isCountCyclesValid) {
            errors.countCycles = {countCycles: 'Значення кількості циклів повинно бути від 1 до 100'};
        } else {
            const activeCycles = (companiesData.callCycles || []).filter((callCycle: any) => callCycle?.isActive !== false);
            const countCyclesErrors: {countCycles?: string; sequentialByCycleMatch?: string} = {};

            activeCycles.forEach((callCycle: any) => {
                const countCallsValue = Number(callCycle.countCalls);
                if (Number.isNaN(countCallsValue)) {
                    return;
                }

                if (countCallsValue > totalCountValue) {
                    if (!errors.callCycles) {
                        errors.callCycles = {};
                    }
                    errors.callCycles[callCycle.typeCall] = {
                        ...(errors.callCycles[callCycle.typeCall] || {}),
                        countCalls: 'Кількість спроб не може перевищувати кількість циклів*'
                    };
                }
            });

            const hasMatchingAttempts = activeCycles.some((callCycle: any) => Number(callCycle.countCalls) === totalCountValue);
            if (activeCycles.length > 0 && !hasMatchingAttempts) {
                countCyclesErrors.sequentialByCycleMatch = 'Хоча б у одного типу контакту кількість спроб має дорівнювати кількості циклів';
            }

            if (Object.keys(countCyclesErrors).length > 0) {
                errors.countCycles = countCyclesErrors;
            }
        }
    }

    if (companiesData?.scheduler && companiesData?.scheduler?.typeScheduler === 401) {
        if (new Date(companiesData.scheduler.startDate) > new Date(companiesData.scheduler.endDate)) {
            errors.startDate = true;
            errors.endDate = true;
        }


        if (new Date(companiesData.scheduler.startTime) > new Date(companiesData.scheduler.endTime)) {
            errors.startTime = true;
            errors.endTime = true;
        }
    }

    if (companiesData?.scheduler && companiesData?.scheduler?.typeScheduler === 403) {
        if (!companiesData?.scheduler?.days?.length) {
            errors.scheduler = {scheduler: 'Графік роботи черги не обрано! Розклад не може бути пустий!*'};
        } else {
            const toTodayTime = (dateStr: string): Date => {
                const time = moment(dateStr, 'MM/DD/YYYY HH:mm:ss', true);
                if (!time.isValid()) return new Date('Invalid Date');

                const today = moment();
                return moment({
                    year: today.year(),
                    month: today.month(),
                    day: today.date(),
                    hour: time.hour(),
                    minute: time.minute(),
                    second: time.second()
                }).toDate();
            };

            const allStartTimesBeforeEndTimes = companiesData?.scheduler?.days?.every((day: {
                start: string | number | Date;
                end: string | number | Date;
            }) => {
                const startTime = toTodayTime(String(day.start));
                const endTime = toTodayTime(String(day.end));

                if (isNaN(startTime.getTime()) || isNaN(endTime.getTime())) return false;

                return startTime < endTime;
            });
            if (!allStartTimesBeforeEndTimes) {
                errors.scheduler = {scheduler: 'Відсутній час або час початку перевищує час завершення*'};
            }
        }
    }
    if (companiesData.campaign.campaignTypeId === 202) {
        // if (companiesData.campaignACD?.mwtAudioId && companiesData.campaignACD?.isMWTAudio) {
        //     if (!companiesData.campaignACD?.mwtAudioTime) {
        //         errors.mwtAudioTime = {mwtAudioTime: 'Поле обов\'язкове для заповнення. Не може бути пустим. *'};
        //     }
        //     if (companiesData.campaignACD?.mwtAudioTime && companiesData.campaignACD?.mwtAudioTime < 10) {
        //         errors.mwtAudioTime = {mwtAudioTime: 'Значення не може бути меньше 10. *'};
        //     }
        // }

        // if (!companiesData.campaignACD?.mwt && !PROD) {
        //     errors.mwt = {mwt: 'Поле обов\'язкове для заповнення. Не може бути пустим. *'};
        // }
        // if (companiesData.campaignACD?.mwt && companiesData.campaignACD?.mwt < 10 && !PROD) {
        //     errors.mwt = {mwt: 'Значення не може бути меньше 10. *'};
        // }

        // if (!companiesData.campaignACD?.mwtNoAgent && !PROD) {
        //     errors.mwtNoAgent = {mwtNoAgent: 'Поле обов\'язкове для заповнення. Не може бути пустим. *'};
        // }
        // if (companiesData.campaignACD?.mwtNoAgent && companiesData.campaignACD?.mwtNoAgent < 1 && !PROD) {
        //     errors.mwtNoAgent = {mwtNoAgent: 'Значення не може бути меньше 1. *'};
        // }
        //
        // if (companiesData.campaignACD?.mwtNoAgentAudioId && companiesData.campaignACD?.isMWTNoAgentAudio) {
        //     if (!companiesData.campaignACD?.mwtNoAgentAudioTime) {
        //         errors.mwtNoAgentAudioTime = {mwtNoAgentAudioTime: 'Поле обов\'язкове для заповнення. Не може бути пустим. *'};
        //     }
        //     if (companiesData.campaignACD?.mwtNoAgentAudioTime && companiesData.campaignACD?.mwtNoAgentAudioTime < 10) {
        //         errors.mwtNoAgentAudioTime = {mwtNoAgentAudioTime: 'Значення не може бути меньше 10. *'};
        //     }
        // }
        //
        // if (companiesData.campaignACD?.mwtStrategy === 202 && !PROD) {
        //     if (!companiesData.campaignACD?.mwtStrategyAction && !PROD) {
        //         errors.mwtStrategyAction = {mwtStrategyAction: 'Поле обов\'язкове для заповнення. Не може бути пустим. *'};
        //     }
        // }
        //
        // if (companiesData.campaignACD?.mwtNoAgentStrategy === 202 && !PROD) {
        //     if (!companiesData.campaignACD?.mwtNoAgentStrategyAction && !PROD) {
        //         errors.mwtNoAgentStrategyAction = {mwtNoAgentStrategyAction: 'Поле обов\'язкове для заповнення. Не може бути пустим. *'};
        //     }
        // }

        // if (!companiesData.campaignACD?.mohAudioId) {
        //     errors.mohAudioId = {mohAudioId: 'Поле обов\'язкове для заповнення. Не може бути пустим. *'};
        // }

        // if (!companiesData.campaignACD?.mwtStrategy && !PROD) {
        //     errors.mwtStrategy = {mwtStrategy: 'Поле обов\'язкове для заповнення. Не може бути пустим. *'};
        // }
        //
        // if (!companiesData.campaignACD?.mwtNoAgentStrategy && !PROD) {
        //     errors.mwtNoAgentStrategy = {mwtNoAgentStrategy: 'Поле обов\'язкове для заповнення. Не може бути пустим. *'};
        // }
        if (companiesData.campaign.campaignTypeId === 202) {
            if (companiesData.campaignACD.isIVMAudio) {
                const audios = companiesData.campaignACD.ivmAudios;
                if (!Array.isArray(audios) || audios.length < 1) {
                    errors.ivmAudios = {ivmAudios: 'Потрібно обрати хоча б один аудіофайл. *'};
                }
            }

            if (!companiesData.campaignACD?.mohAudioTime || companiesData.campaignACD?.mohAudioTime < 10) {
                let errorMessage = 'Поле обов\'язкове для заповнення. Не може бути пустим. *';
                if (companiesData.campaignACD?.mohAudioTime && companiesData.campaignACD?.mohAudioTime < 10) {
                    errorMessage = 'Значення не може бути меньше 10. *';
                }
                errors.mohAudioTime = {mohAudioTime: errorMessage};
            }
        }
    }

    if (!companiesData.campaign.timeoutExternalOnAnswer || companiesData.campaign.timeoutExternalOnAnswer < 10) {
        let errorMessage = 'Поле обов\'язкове для заповнення. Не може бути пустим. *';
        if (companiesData.campaign.timeoutExternalOnAnswer && companiesData.campaign.timeoutExternalOnAnswer < 10) {
            errorMessage = 'Значення не може бути меньше 10. *';
        }
        errors.timeoutExternalOnAnswer = {timeoutExternalOnAnswer: errorMessage};
    }

    if (companiesData?.campaign?.isAMD) {
        const amdFields = [
            'maximum_number_of_words',
            'between_words_silence',
            'maximum_word_length',
            'min_word_length',
            'total_analysis_time',
            'silence_threshold',
            'after_greeting_silence',
            'greeting',
            'initial_silence',
        ] as const;

        const amdErrors: Record<string, string> = {};
        for (const field of amdFields) {
            const val = companiesData?.campaignAMD?.[field];
            if (val === null || val === undefined || val < 1 || val > 9999) {
                amdErrors[field] = 'Значення повинно бути від 1 до 9999 *';
            }
        }

        const hangup = companiesData?.campaignAMD?.hangup_on_machine;
        if (!Array.isArray(hangup) || hangup.length < 1) {
            amdErrors['hangup_on_machine'] = 'Потрібно обрати хоча б один параметр *';
        }

        if (Object.keys(amdErrors).length > 0) {
            errors.campaignAMD = amdErrors;
        }
    }

    if (companiesData.campaign.campaignTypeId === 205) {

        if (!companiesData.campaignACD?.mohAudioId) {
            errors.mohAudioId = {mohAudioId: 'Поле обов\'язкове для заповнення. Не може бути пустим. *'};
        }

        if (!companiesData.campaignACD?.mohAudioTime || companiesData.campaignACD?.mohAudioTime < 10) {
            let errorMessage = 'Поле обов\'язкове для заповнення. Не може бути пустим. *';
            if (companiesData.campaignACD?.mohAudioTime && companiesData.campaignACD?.mohAudioTime < 10) {
                errorMessage = 'Значення не може бути меньше 10. *';
            }
            errors.mohAudioTime = {mohAudioTime: errorMessage};
        }
    }

    return Object.keys(errors).length > 0 ? errors : null;
}

export function validateTrunkData(trunkData: any) {
    const errors: TrunkFormErrors = {};
    const phones = Array.isArray(trunkData.phones) ? trunkData.phones : [];
    const nonArchivedPhones = phones.filter(
        (p: { isArchived?: boolean }) => p?.isArchived !== true,
    );
    const listInboundPhones = Array.isArray(trunkData.listInboundPhones)
        ? trunkData.listInboundPhones
        : [];
    const listOutboundPhones = Array.isArray(trunkData.listOutboundPhones)
        ? trunkData.listOutboundPhones
        : [];

    if (!trunkData.name) {
        errors.name = {name: 'Вкажіть назву транка *'};
    }

    const branchId =
        trunkData.branchId ?? trunkData.BranchId ?? trunkData.mainBranchId;
    if (branchId == null || branchId === "") {
        errors.branchId = {branchId: "Виберіть бранч *"};
    }

    const defaultTrunkId =
        trunkData.defaultTrunkId ?? trunkData.DefaultTrunkId;
    if (defaultTrunkId == null || defaultTrunkId === "") {
        errors.defaultTrunkId = {
            defaultTrunkId: "Оберіть транк за замовчуванням *",
        };
    }

    if (!nonArchivedPhones.length) {
        errors.phones = {phones: 'Відсутні телефони'};
    }

    const normalizeLinePhone = (raw: unknown) =>
        raw == null ? '' : String(raw).replace(/\s+/g, '').trim();

    const phoneIndexesByNumber = new Map<string, number[]>();
    phones.forEach((row: { phoneNo?: unknown }, index: number) => {
        const p = normalizeLinePhone(row?.phoneNo);
        if (!p) return;
        const indexes = phoneIndexesByNumber.get(p) ?? [];
        indexes.push(index);
        phoneIndexesByNumber.set(p, indexes);
    });

    phones.forEach((row: { phoneNo?: unknown; isArchived?: boolean }, index: number) => {
        if (row?.isArchived === true) {
            return;
        }
        const p = normalizeLinePhone(row?.phoneNo);
        if (!p) {
            if (!errors.phoneRowErrors) errors.phoneRowErrors = {};
            errors.phoneRowErrors[index] = 'Вкажіть номер *';
            return;
        }
        const sameNumberIndexes = phoneIndexesByNumber.get(p) ?? [];
        if (sameNumberIndexes.length > 1) {
            if (!errors.phoneRowErrors) errors.phoneRowErrors = {};
            errors.phoneRowErrors[index] = 'Такий номер вже існує *';
            return;
        }
    //     if (p.length < 12) {
    //         if (!errors.phoneRowErrors) errors.phoneRowErrors = {};
    //         errors.phoneRowErrors[index] = 'Номер не може бути менше 12 символів *';
    //         return;
    //     }
    //     if (!p.startsWith('380')) {
    //         if (!errors.phoneRowErrors) errors.phoneRowErrors = {};
    //         errors.phoneRowErrors[index] = 'Номери повинні починатися з 380 *';
    //     }
    });

    if (errors.phoneRowErrors && Object.keys(errors.phoneRowErrors).length > 0) {
        errors.phones = {
            phones: 'Перевірте заповнення номерів',
        };
    }

    if (trunkData.limitAttemptsCall !== null) {
        if (trunkData.limitAttemptsCall < 1) {
            errors.limitAttemptsCall = {limitAttemptsCall: 'Значення не може бути менше 1'};
        } else if (trunkData.limitAttemptsCall > 100) {
            errors.limitAttemptsCall = {limitAttemptsCall: 'Значення не може бути більше 100'};
        }
    }

    if (listInboundPhones.length) {
        const hasEmptyStringsOrNull = listInboundPhones.some((phone: string | null) =>
            phone === null || phone.trim() === ''
        );

        const hasInvalidLength = listInboundPhones.some((phone: string | null) =>
            phone !== null && phone.trim() !== '' && phone.trim().length < 12
        );

        const hasInvalidPrefix = listInboundPhones.some((phone: string | null) =>
            phone !== null && phone.trim() !== '' && !phone.trim().startsWith('380')
        );

        if (hasEmptyStringsOrNull) {
            errors.listInboundPhones = {listInboundPhones: 'Поле номера не може бути порожнім *'};
        } else if (hasInvalidLength) {
            errors.listInboundPhones = {listInboundPhones: 'Номер не може бути менше 12 символів *'};
        } else if (hasInvalidPrefix) {
            errors.listInboundPhones = {listInboundPhones: 'Номери повинні починатися з 380 *'};
        }
    }

    if (listOutboundPhones.length) {
        const hasEmptyStringsOrNull = listOutboundPhones.some((phone: string | null) =>
            phone === null || phone.trim() === ''
        );

        const hasInvalidLength = listOutboundPhones.some((phone: string | null) =>
            phone !== null && phone.trim() !== '' && phone.trim().length < 12
        );

        const hasInvalidPrefix = listOutboundPhones.some((phone: string | null) =>
            phone !== null && phone.trim() !== '' && !phone.trim().startsWith('380')
        );

        if (hasEmptyStringsOrNull) {
            errors.listOutboundPhones = {listOutboundPhones: 'Поле номера не може бути порожнім *'};
        } else if (hasInvalidLength) {
            errors.listOutboundPhones = {listOutboundPhones: 'Номер не може бути менше 12 символів *'};
        } else if (hasInvalidPrefix) {
            errors.listOutboundPhones = {listOutboundPhones: 'Номери повинні починатися з 380 *'};
        }
    }

    if (trunkData.needPaiNumber === true) {
        const rawPai =
            trunkData.outPrefix?.pai_Number ?? trunkData.outPrefix?.paiNumber;
        const paiStr = rawPai == null ? "" : String(rawPai).trim();
        if (!paiStr) {
            errors.paiNumber = {
                pai_Number: "Поле [Pai_Number] обов'язкове *",
            };
        }
    }

    return Object.keys(errors).length > 0 ? errors : null;
}

export function validateQueueData(queueData: any) {
    const errors: QueueFormErrors = {};

    if (!queueData.queue.name) {
        errors.name = {name: 'Вкажіть назву черги *'};
    }
    if (queueData?.queue?.queueType === 702) {
        if (queueData.queueACD.isIVMAudio) {
            const audios = queueData?.queueACD?.ivmAudios;
            if (!Array.isArray(audios) || audios.length < 1) {
                // errors.ivmAudios = {ivmAudios: 'Потрібно обрати хоча б один аудіофайл. *'};
            }
        } else {
            if (!queueData?.queueACD?.ivrConfigurationId) {
                errors.ivrConfigurationId = {ivrConfigurationId: 'Потрібно обрати IVR конфігурацію. *'};
            }
        }
        if (!queueData?.queueACD?.ivrConfigurationId) {
            errors.ivrConfigurationId = {ivrConfigurationId: 'Потрібно обрати IVR конфігурацію. *'};
        }
    }
    if (queueData?.queue?.queueType === 701) {
        if (queueData.queueACD?.schedulerAudioId && queueData.queueACD?.isSchedulerAudio) {
            if (!queueData.queueACD.schedulerAudioTime) {
                errors.schedulerAudioTime = {schedulerAudioTime: 'Поле обов\'язкове для заповнення. Не може бути пустим. *'};
            }
            if (queueData.queueACD.schedulerAudioTime && queueData.queueACD.schedulerAudioTime < 10) {
                errors.schedulerAudioTime = {schedulerAudioTime: 'Значення не може бути меньше 10. *'};
            }
        }

        // if (queueData.queueACD.isIVRAudio) {
        //     const audioRetries = queueData.queueACD.ivrAudioRetries;
        //
        //     if (!audioRetries || audioRetries < 1 || audioRetries > 100) {
        //         errors.audioRetries = {audioRetries: 'Значення не може бути меньше 1. *'};
        //     }
        // }

        if (queueData.queueACD?.mwtAudioId && queueData.queueACD?.isMWTAudio) {
            if (!queueData.queueACD.mwtAudioTime) {
                errors.mwtAudioTime = {mwtAudioTime: 'Поле обов\'язкове для заповнення. Не може бути пустим. *'};
            }
            if (queueData.queueACD.mwtAudioTime && queueData.queueACD.mwtAudioTime < 10) {
                errors.mwtAudioTime = {mwtAudioTime: 'Значення не може бути меньше 10. *'};
            }
        }

        if (!queueData.queueACD?.mwt && !PROD) {
            errors.mwt = {mwt: 'Поле обов\'язкове для заповнення. Не може бути пустим. *'};
        }
        if (queueData.queueACD?.mwt && queueData.queueACD?.mwt < 10 && !PROD) {
            errors.mwt = {mwt: 'Значення не може бути меньше 10. *'};
        }

        if (!queueData.queueACD?.mwtNoAgent && !PROD) {
            errors.mwtNoAgent = {mwtNoAgent: 'Поле обов\'язкове для заповнення. Не може бути пустим. *'};
        }
        if (queueData.queueACD?.mwtNoAgent && queueData.queueACD?.mwtNoAgent < 1 && !PROD) {
            errors.mwtNoAgent = {mwtNoAgent: 'Значення не може бути меньше 1. *'};
        }

        if (queueData.queueACD?.mwtNoAgentAudioId && queueData.queueACD?.isMWTNoAgentAudio) {
            if (!queueData.queueACD?.mwtNoAgentAudioTime) {
                errors.mwtNoAgentAudioTime = {mwtNoAgentAudioTime: 'Поле обов\'язкове для заповнення. Не може бути пустим. *'};
            }
            if (queueData.queueACD?.mwtNoAgentAudioTime && queueData.queueACD?.mwtNoAgentAudioTime < 10) {
                errors.mwtNoAgentAudioTime = {mwtNoAgentAudioTime: 'Значення не може бути меньше 10. *'};
            }
        }

        if (queueData.queueACD?.schedulerStrategy === 202) {
            if (!queueData.queueACD.schedulerStrategyAction) {
                errors.schedulerStrategyAction = {schedulerStrategyAction: 'Поле обов\'язкове для заповнення. Не може бути пустим. *'};
            }
        }

        if (queueData.queueACD?.mwtStrategy === 202 && !PROD) {
            if (!queueData.queueACD.mwtStrategyAction && !PROD) {
                errors.mwtStrategyAction = {mwtStrategyAction: 'Поле обов\'язкове для заповнення. Не може бути пустим. *'};
            }
        }

        if (queueData.queueACD?.mwtNoAgentStrategy === 202 && !PROD) {
            if (!queueData.queueACD?.mwtNoAgentStrategyAction && !PROD) {
                errors.mwtNoAgentStrategyAction = {mwtNoAgentStrategyAction: 'Поле обов\'язкове для заповнення. Не може бути пустим. *'};
            }
        }

        if (!queueData.queueACD?.mohAudioId) {
            errors.mohAudioId = {mohAudioId: 'Поле обов\'язкове для заповнення. Не може бути пустим. *'};
        }

        if (!queueData.queueACD?.schedulerAudioId) {
            errors.schedulerAudioId = {schedulerAudioId: 'Поле обов\'язкове для заповнення. Не може бути пустим. *'};
        }

        if (!queueData.queueACD?.schedulerStrategy) {
            errors.schedulerStrategy = {schedulerStrategy: 'Поле обов\'язкове для заповнення. Не може бути пустим. *'};
        }

        if (!queueData.queueACD?.mwtStrategy && !PROD) {
            errors.mwtStrategy = {mwtStrategy: 'Поле обов\'язкове для заповнення. Не може бути пустим. *'};
        }

        if (!queueData.queueACD?.mwtNoAgentStrategy && !PROD) {
            errors.mwtNoAgentStrategy = {mwtNoAgentStrategy: 'Поле обов\'язкове для заповнення. Не може бути пустим. *'};
        }

        if (!queueData.queueACD?.mohAudioTime || queueData.queueACD?.mohAudioTime < 10) {
            let errorMessage = 'Поле обов\'язкове для заповнення. Не може бути пустим. *';
            if (queueData.queueAC?.mohAudioTime && queueData.queueACD?.mohAudioTime < 10) {
                errorMessage = 'Значення не може бути меньше 10. *';
            }
            errors.mohAudioTime = {mohAudioTime: errorMessage};
        }

        if (queueData?.queueUsers?.length) {
            const usersWithMissingLevel = queueData.queueUsers.filter((item: {
                userLevel: null | undefined;
            }) => item.userLevel === null || item.userLevel === undefined);

            if (usersWithMissingLevel.length > 0) {
                errors.queueUsers = {queueUsers: 'Рівень оператора не може бути порожнім*', queueUsersWithoutLevel: usersWithMissingLevel};
            }
        }

        if (!queueData?.queueUsers?.length && queueData?.queue?.isActive) {
            errors.queueUsers = {queueUsers: 'Додайте оператора або групу*', queueUsersWithoutLevel: null};
        }

        if (!queueData?.scheduler?.days?.length) {
            errors.scheduler = {scheduler: 'Графік роботи черги не обрано! Розклад не може бути пустий!*'};
        } else {

            const toTodayTime = (dateStr: string): Date => {
                const time = moment(dateStr, 'MM/DD/YYYY HH:mm:ss', true);
                if (!time.isValid()) return new Date('Invalid Date');

                const today = moment();
                return moment({
                    year: today.year(),
                    month: today.month(),
                    day: today.date(),
                    hour: time.hour(),
                    minute: time.minute(),
                    second: time.second()
                }).toDate();
            };

            const allStartTimesBeforeEndTimes = queueData?.scheduler?.days?.every((day: {
                start: string | number | Date;
                end: string | number | Date;
            }) => {
                const startTime = toTodayTime(String(day.start));
                const endTime = toTodayTime(String(day.end));

                if (isNaN(startTime.getTime()) || isNaN(endTime.getTime())) return false;

                return startTime < endTime;
            });

            // const allStartTimesBeforeEndTimes = queueData?.scheduler?.days?.every((day: {
            //     start: string | number | Date;
            //     end: string | number | Date;
            // }) => {
            //     const startTime = new Date(day.start);
            //     const endTime = new Date(day.end);
            //     return startTime < endTime;
            // });
            //
            // console.log(allStartTimesBeforeEndTimes)
            if (!allStartTimesBeforeEndTimes) {
                errors.scheduler = {scheduler: 'Відсутній час або час початку перевищує час завершення*'};
            }
        }
    }

    if (!queueData.queueBranches.length) {
        errors.branchId = true;
    }

    if (queueData?.queue?.isQueueTrunk) {
        const trunks = queueData.queueTrunks || [];

        if (!trunks.length) {
            errors.queueTranks = {queueTranks: 'Відсутні транк'};
        } else {
            const trunkGroups: Record<number | string, any[]> = {};

            for (const trunk of trunks) {
                if (!trunk.trunkId) {
                    errors.queueTranks = {queueTranks: 'Заповніть усі поля транків'};
                    break;
                }

                if (!trunkGroups[trunk.trunkId]) {
                    trunkGroups[trunk.trunkId] = [];
                }
                trunkGroups[trunk.trunkId].push(trunk);
            }

            const errorTrunkIds: number[] = [];
            const hasInvalidTrunkGroup = Object.values(trunkGroups).some((group) => {
                const hasNull = group.some((t: any) => t.trunkPhoneId === null);
                if (group.length > 1 && hasNull) {
                    group.forEach((item) => {
                        if (!errorTrunkIds.includes(item.trunkId)) {
                            errorTrunkIds.push(item.trunkId);
                        }
                    });
                    return true;
                }
                return false;
            });

            if (!errors.queueTranks && hasInvalidTrunkGroup) {
                errors.queueTranks = {
                    queueTranks: 'Цей транк вже додано в чергу',
                    trunkIds: errorTrunkIds,
                };
            }
        }
    }

    return Object.keys(errors).length > 0 ? errors : null;
}

export function validateBranchForm(branchData: any) {
    const errors: BranchDataFormErrors = {};

    if (!branchData.name) {
        errors.name = {name: 'Ім\'я поточного бранча не може бути порожньою'};
    }

    return Object.keys(errors).length > 0 ? errors : null;
}

export function validateTechUserBranchForm(newTechUser: any) {
    const errors: TechDataFormErrors = {};
    if (!newTechUser.password) {
        errors.password = true;
    } else {
        const regex = /^(?=.*[a-zа-я])(?=.*[A-ZА-Я])(?=.*\d)[\d\S]{8,}$/;


        if (!regex.test(newTechUser.password)) {
            errors.password = {password: 'Пароль повинен містити мінімум одну велику літеру, одну маленьку літеру, одну цифру та містити не менше 8 символів.'};
        }
    }

    if (!newTechUser.userName) {
        errors.userName = true;
    } else {
        if (newTechUser.userName.length < 4) {
            errors.userName = {
                name: "Логін має бути не менше 4 символів."
            };
        } else {
            const regex = /^[A-Za-z\d._!*]*[A-Za-z]+[\d._!*]*$/;
            if (!regex.test(newTechUser.userName)) {
                errors.userName = {
                    name: `Недопустимі символи! Логін має містити хоча б одну літеру. Використовуйте символи A-Z a-z 0-9 . _ ! * .`
                };
            }
        }
    }

    if (!newTechUser.techUserPermissions?.length) {
        errors.techUserPermissions = true;
    }
    return Object.keys(errors).length > 0 ? errors : null;
}

export function validateRoleForm(rolesData: any) {
    const errors: RoleDataFormErrors = {};
    const hasPermissionIdNotNull = rolesData?.roleModules.find((module: {
        permissionId: null;
    }) => module.permissionId !== null);
    if (!rolesData.name) {
        errors.name = {name: 'Назва ролі не може бути порожньою'};
    }

    if (!hasPermissionIdNotNull) {
        errors.permissionId = {description: 'Додайте доступний розділ'};
    }

    if (!rolesData.roleBranches?.length) {
        errors.branchId = true;
    }

    return Object.keys(errors).length > 0 ? errors : null;
}

export function validateStatusForm(statusData: any) {
    const errors: StatusDataFormErrors = {};
    if (!statusData.statusName) {
        errors.name = {name: 'Назва статусу не може бути порожньою'};
    }
    if (!statusData.timeStatus) {
        errors.timeStatus = {timeStatus: 'Не може бути порожньою'};
    }

    if (!statusData.statusBranches?.length) {
        errors.branchId = true;
    }

    return Object.keys(errors).length > 0 ? errors : null;
}

export function validateAudioForm(audioData: any) {
    const errors: AudioDataFormErrors = {};
    if (!audioData.groupName) {
        errors.groupName = {name: 'Назва аудіо не може бути порожньою'};
    }
    if (!audioData.audioGroupBranches?.length) {
        errors.branchId = true;
    }

    // if (!audioData.audios?.length) {
    //     errors.audioFileName = {audioFileName: 'Завантажте аудіо'};
    // }

    return Object.keys(errors).length > 0 ? errors : null;
}

export function validateRecoveryEmail(data: any) {
    const errors: recoveryEmailErrors = {};
    if (!data) {
        errors.name = {name: 'Поле не може бути порожнім*'};
    }

    return Object.keys(errors).length > 0 ? errors : null;
}

export function validateIVRConfigurationData(ivrConfigurationData: any) {
    const errors: IVRConfigurationFormErrors = {};

    if (!ivrConfigurationData.name) {
        errors.name = {name: 'Назва IVR конфігурації не може бути порожньою *'};
    }

    if (!ivrConfigurationData.branchId) {
        errors.branchId = true;
    }

    return Object.keys(errors).length > 0 ? errors : null;
}

export function validateAudioControlData(audioControlData: any) {
    const errors: AudioControlFormErrors = {};

    if (!audioControlData?.name) {
        errors.name = {name: 'Вкажіть назву *'};
    }

    const branchId = audioControlData?.branchId ?? audioControlData?.BranchId;
    if (branchId == null || branchId === "") {
        errors.branchId = {branchId: "Виберіть бранч *"};
    }

    const blocks = Array.isArray(audioControlData?.blocks) ? audioControlData.blocks : [];
    const activeBlocks = blocks.filter((block: any) => isAudioControlBlockCounted(block));
    const totalBlockWeight = sumWeights(activeBlocks);
    if (Math.abs(totalBlockWeight - 100) >= 0.001) {
        errors.questionnaire = {questionnaire: 'Сума ваг блоків має дорівнювати 100% *'};
    }

    const blockErrors: NonNullable<AudioControlFormErrors['blockErrors']> = {};

    blocks.forEach((block: any, blockIndex: number) => {
        const isBlockActive = isAudioControlBlockCounted(block);
        const currentBlockErrors: NonNullable<AudioControlFormErrors['blockErrors']>[number] = {};
        const conditions = Array.isArray(block?.conditions) ? block.conditions : [];

        if (!String(block?.name ?? '').trim()) {
            currentBlockErrors.name = true;
        }

        if (isBlockActive) {
            if (block?.weight == null || block?.weight === '') {
                currentBlockErrors.weight = true;
            }

            const countedConditions = conditions.filter((condition: any) => isAudioControlConditionCounted(condition));
            const conditionsWeight = sumWeights(countedConditions);
            if (Math.abs(conditionsWeight - 100) >= 0.001) {
                errors.blocks = {blocks: `Сума ваг елементів у блоці ${blockIndex + 1} має дорівнювати 100% *`};
            }
        }

        conditions.forEach((condition: any, conditionIndex: number) => {
            if (!isAudioControlConditionCounted(condition)) {
                return;
            }

            const conditionErrors: NonNullable<NonNullable<AudioControlFormErrors['blockErrors']>[number]['conditions']>[number] = {};

            if (!String(condition?.condition ?? '').trim()) {
                conditionErrors.condition = true;
            }

            if (!String(condition?.scenario ?? '').trim()) {
                conditionErrors.scenario = true;
            }

            if (isBlockActive && (condition?.weight == null || condition?.weight === '')) {
                conditionErrors.weight = true;
            }

            if (!String(condition?.failCondition ?? '').trim()) {
                conditionErrors.failCondition = true;
            }

            if (Object.keys(conditionErrors).length > 0) {
                currentBlockErrors.conditions = currentBlockErrors.conditions ?? {};
                currentBlockErrors.conditions[conditionIndex] = conditionErrors;
            }
        });

        if (Object.keys(currentBlockErrors).length > 0) {
            blockErrors[blockIndex] = currentBlockErrors;
        }
    });

    if (Object.keys(blockErrors).length > 0) {
        errors.blockErrors = blockErrors;
        errors.blocks = {blocks: 'Заповніть обов\'язкові поля в блоках анкети *'};
    }

    return Object.keys(errors).length > 0 ? errors : null;
}


